import {Pipe, PipeTransform} from '@angular/core';
import {EventDto} from '../../Models/Events/event.interface';

@Pipe({
  name: 'events',
  standalone: false
})
export class EventsPipe implements PipeTransform {

  transform(items: EventDto[], filter: { state?: number, family?: number }): EventDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.state) {
      items = items.filter((item) => item.id_estado == filter.state);
    }

    if (filter.family) {
      items = items.filter((item) => item.family_id == filter.family);
    }

    return items;

  }

}
